module.exports = __webpack_public_path__ + "img/book-10.06e23b69.png";